export const NOTIFICATION_TYPE = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ALERT: 'ALERT',
};
